module.exports = __webpack_public_path__ + "static/on-d739e8376327190f08a18c66b3736962.png";